import React, { useState, useEffect } from 'react';
import '../css/HalvingCarousel.css';

const HalvingCarousel = () => {
  const [blockCount, setBlockCount] = useState(0);
  const [currentHalvingIndex, setCurrentHalvingIndex] = useState(0);
  const [halvings, setHalvings] = useState([]);
  const [loading, setLoading] = useState(true); 

  const initialBlockDate = new Date('2024-04-27T14:03:51Z');
  const totalCoins = 500_000_000;
  const blocksPerDay = 1440; 

  useEffect(() => {
    const generateHalvings = () => {
      const initialRewards = [
        { number: 0, reward: 600, startBlock: 0, endBlock: 129600, name: 'Mainnet Launch' },
        { number: 1, reward: 540, startBlock: 129601, endBlock: 259200 },
        { number: 2, reward: 459, startBlock: 259201, endBlock: 388800 },
        { number: 3, reward: 367.2, startBlock: 388801, endBlock: 518400 },
        { number: 4, reward: 200, startBlock: 518401, endBlock: 1036800 }
      ];


    let reward = 100; 
    let halvingNumber = 5;
    let totalDistributedCoins = 0;
    let startBlock = 1036801;
    let startDate = new Date(initialBlockDate.getTime() + (1036800 / blocksPerDay) * 24 * 60 * 60 * 1000); 

    const halvingsData = initialRewards.map((halving) => {
      const startDate = new Date(initialBlockDate.getTime() + (halving.startBlock / blocksPerDay) * 24 * 60 * 60 * 1000);
      const endDate = new Date(initialBlockDate.getTime() + (halving.endBlock / blocksPerDay) * 24 * 60 * 60 * 1000);
      return {
        ...halving,
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
      };
    });

    while (totalDistributedCoins < totalCoins && halvingNumber <= 13) {
      const periodDays = halvingNumber <= 6 ? 360 : halvingNumber <= 8 ? 720 : 1440;
      const coinsPerDay = reward * blocksPerDay;
      const coinsThisPeriod = coinsPerDay * periodDays;

      if (totalDistributedCoins + coinsThisPeriod > totalCoins) {
        reward = ((totalCoins - totalDistributedCoins) / periodDays) / blocksPerDay;
      }

      totalDistributedCoins += Math.min(coinsThisPeriod, totalCoins - totalDistributedCoins);

      const endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + periodDays);

      halvingsData.push({
        number: halvingNumber,
        reward: reward.toFixed(2),
        startDate: startDate.toISOString().split('T')[0],
        endDate: endDate.toISOString().split('T')[0],
        startBlock,
        endBlock: startBlock + blocksPerDay * periodDays - 1,
      });

      halvingNumber++;
      startDate = new Date(endDate); 
      startBlock = startBlock + blocksPerDay * periodDays;
      reward = reward / 2;
    }

    setHalvings(halvingsData);
    setLoading(false); 
  };

  generateHalvings();
}, []);

  useEffect(() => {
    const fetchBlockCount = async () => {
      try {
        const response = await fetch('https://aidp-rpc-mainnet.ai-depin.org/rpc', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jsonrpc: '2.0',
            method: 'getblockcount',
            params: [],
            id: 1,
          }),
        });

        const data = await response.json();
        setBlockCount(data.result);
        updateCurrentHalving();
      } catch (error) {
        console.error('Error fetching block count through RPC proxy:', error);
      }
    };

    if (halvings.length > 0) {
      fetchBlockCount();
    }
  }, [halvings]);

  const updateCurrentHalving = () => {
    const today = new Date();
    const halvingIndex = halvings.findIndex(
      (halving) =>
        today >= new Date(halving.startDate) && today <= new Date(halving.endDate)
    );
    setCurrentHalvingIndex(halvingIndex !== -1 ? halvingIndex : 0);
  };

  const getAIDPPerDay = (reward) => {
    return (reward * blocksPerDay).toFixed(2);
  };

  const goToPrevious = () => {
    if (currentHalvingIndex > 0) {
      setCurrentHalvingIndex(currentHalvingIndex - 1);
    }
  };

  const goToNext = () => {
    if (currentHalvingIndex < halvings.length - 1) {
      setCurrentHalvingIndex(currentHalvingIndex + 1);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const isAtStart = currentHalvingIndex === 0;
  const isAtEnd = currentHalvingIndex === halvings.length - 1;

  return (
    <div className="halving-description">
      <h2>Halving Information</h2>
      <p>
        Access comprehensive information on all halving events, including past and upcoming halvings,
        remaining blocks until the next event, expected dates, and adjusted block rewards.
      </p>
      <div className="carousel-navigation">
        {!isAtStart && (
          <button className="carousel-nav left" onClick={goToPrevious}>
            <div className="wrapper">
              <svg width="18px" height="17px" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
                <g id="prev" transform="translate(8.500000, 8.500000) scale(-1, 1) translate(-8.500000, -8.500000)">
                  <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                  <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                  <path d="M0,0.56157424 L0,16.1929159 L9.708,8.33860465 L0,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 Z"></path>
                </g>
              </svg>
            </div>
          </button>
        )}

        <div className="carousel">
          {halvings
            .slice(
              isAtStart ? currentHalvingIndex : currentHalvingIndex - 1,
              isAtEnd ? currentHalvingIndex + 1 : currentHalvingIndex + 2
            )
            .map((halving, index) => (
              <div
                className={`carousel-item ${
                  index === (isAtStart ? 0 : 1) ? 'active' : index === 0 ? 'previous' : 'next'
                }`}
                key={halving.number}
              >
                <div className="halving-info">
                  <div className="info-item">
                    <strong>{halving.name || `Halving`}</strong>
                    <span>#{halving.number}</span>
                  </div>
                  <div className="info-item">
                    <strong>Reward per Block:</strong>
                    <span>{halving.reward} AIDP</span>
                  </div>
                  <div className="info-item">
                    <strong>AIDP Mined per Day:</strong>
                    <span>{getAIDPPerDay(halving.reward)} AIDP</span>
                  </div>
                  <div className="info-item">
                    <strong>Period:</strong>
                    <span>Start date: {halving.startDate}</span>
                    <span>End date: {halving.endDate}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {!isAtEnd && (
          <button className="carousel-nav right" onClick={goToNext}>
            <div className="wrapper">
              <svg width="18px" height="17px" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                  <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                  <path d="M0,0.56157424 L0,16.1929159 L9.708,8.33860465 L0,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 Z"></path>
                </g>
              </svg>
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default HalvingCarousel;
